module.exports = __webpack_public_path__ + "static/media/history_23.15ed99ad.jpg";